import { lazy, useEffect, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import { PAGES, CATALOG } from "@/data/site";
import { initAnalytics } from "@/lib/analytics";

const ContentPage = lazy(() => import("@/pages/ContentPage"));
const HubPage = lazy(() => import("@/pages/HubPage"));
const Booking = lazy(() => import("@/pages/Booking").then((m) => ({ default: m.Booking })));
const Contact = lazy(() => import("@/pages/Booking").then((m) => ({ default: m.Contact })));
const Tariff = lazy(() => import("@/pages/Info").then((m) => ({ default: m.Tariff })));
const Reviews = lazy(() => import("@/pages/Info").then((m) => ({ default: m.Reviews })));
const Gallery = lazy(() => import("@/pages/Info").then((m) => ({ default: m.Gallery })));
const NotFound = lazy(() => import("@/pages/Info"));
const Admin = lazy(() => import("@/pages/Admin"));

export default function App() {
  useEffect(() => { initAnalytics(); }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Suspense fallback={null}><Admin /></Suspense>} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tariff" element={<Tariff />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/gallery" element={<Gallery />} />
          {(CATALOG.hubs || []).map((h) => <Route key={h.path} path={h.path} element={<HubPage />} />)}
          {PAGES.map((p) => <Route key={p.path} path={p.path} element={<ContentPage />} />)}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
